import ArticleLayout from '@/components/feature/ArticleLayout';
import { articlesBySlug } from '@/mocks/articles';

export default function KakobuyWysylkaPolska() {
  return <ArticleLayout article={articlesBySlug['kakobuy-wysylka-do-polski']} />;
}